export const buildUploadReportFileCommand = ({ reportCommandId, fileName, workspaceName }) => ({
  command_id: reportCommandId,
  name: fileName,
  workspaceName,
  fileType: 'file',
  error: false,
  finished: false
});

export const buildHiddenUploadReportGroupingCommand = ({
  reportCommandId,
  workspaceName,
  groupingStartTimestamp
}) => ({
  command_id: reportCommandId,
  commandType: 'grouping',
  name: workspaceName,
  workspaceName,
  fileType: 'grouping',
  isGrouping: true,
  groupingStartTimestamp,
  hideFromQueue: true,
  error: false,
  finished: false
});
